import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { CirclePlayIcon } from 'images'

// "Website" page chrome around a large in-article native card: browser-style
// top bar showing the display URL, then image left / headline, description,
// advertiser name, and "Learn more" button on the right (Figma nodes
// 31516:16349/16381, 31518:16611 desktop-general — see googleDisplayVariations.js).
//
// When the creative has a video item (`ad.youtubeBottomMedia`), a small nested
// video-thumbnail row (the YouTube Home/Watch feed surface for Demand Gen) is
// rendered below, optionally alongside a `companion_banner` image.
const NativeArticleCard = ({ ad }) => {
  const {
    headline,
    description,
    media,
    businessName,
    callToAction,
    displayUrlPath,
    youtubeBottomMedia,
    companionBanner,
  } = ad
  const domain = displayUrlPath?.url ?? ''

  return (
    <div className="google-display-card google-display-card--native">
      <div className="google-display-card__browser-bar">
        <span className="google-display-card__browser-dot" />
        <span className="google-display-card__browser-dot" />
        <span className="google-display-card__browser-dot" />
        <span className="google-display-card__browser-url">{domain}</span>
      </div>
      <div className="google-display-card__native-body">
        <div className="google-display-card__native-placeholder" />
        <div className="google-display-card__native-article">
          {/* visibleByDefault: see BareGradientCard.jsx — avoids the
              lazy-load placeholder's raw-pixel inline height inflating a
              horizontally-scrolling row for any card not yet scrolled into
              view. */}
          <LazyLoadImage
            className="google-display-card__native-media"
            src={media?.url}
            alt={media?.filename}
            width={media?.width}
            height={media?.height}
            visibleByDefault
          />
          <div className="google-display-card__native-text">
            <div className="google-display-card__headline">{headline}</div>
            <div className="google-display-card__description">{description}</div>
            <div className="google-display-card__advertiser">{businessName}</div>
            <button type="button" className="google-display-card__cta-pill">
              {callToAction}
            </button>
          </div>
        </div>
        {youtubeBottomMedia && (
          <div className="google-display-card__yt-bottom">
            <span className="google-display-card__yt-bottom-thumb">
              <CirclePlayIcon className="google-display-card__yt-bottom-play" />
            </span>
            <div className="google-display-card__yt-bottom-text">
              <span className="google-display-card__ad-tag google-display-card__ad-tag--inline">
                Ad
              </span>
              <span className="google-display-card__yt-bottom-label">YouTube</span>
            </div>
            {companionBanner?.url && (
              <img
                className="google-display-card__yt-bottom-banner"
                src={companionBanner.url}
                alt={businessName}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

NativeArticleCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    callToAction: PropTypes.string,
    media: PropTypes.object,
    businessName: PropTypes.string,
    displayUrlPath: PropTypes.object,
    youtubeBottomMedia: PropTypes.object,
    companionBanner: PropTypes.object,
  }).isRequired,
}

export default NativeArticleCard
